<p-dialog header="Request Changes" [(visible)]="showDialog" [modal]="true" (onHide)="closeDialog(false)" [blockScroll]="true">
    <textarea [rows]="5" [cols]="60" pInputTextarea placeholder="Enter request here..." style="border-radius: 2px;" [(ngModel)]="changeRequest" (ngModelChange)="changeRequestUpdated()"></textarea>
  <div class="footer">
    <p-button type="button" (click)="sendRequest()" label="Send" [disabled]="disableSubmit"></p-button>
    <p-button type="button" (click)="cancel()" label="Cancel" severity="info"></p-button>
  </div>
</p-dialog>